import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular';
import { AppGlobals } from '../../../app.globals';
import { ConfigService } from '../../../services/config.service';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { relative } from 'path';
import { Subscription } from 'rxjs';

import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
@Component({
    selector: 'app-project-config',
    imports: [CommonModule, DxButtonModule, RouterLink, RouterLinkActive, RouterOutlet],
    templateUrl: './project-config.component.html',
    styleUrl: './project-config.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectConfigComponent implements OnInit, OnDestroy {
  tabs = [
    {
      text: $localize`:@@phasesMilestonesTasks:Phases, Milestones, Tasks`,
      link: 'configuration',
    },
    {
      text: $localize`:@@projectParameters:Project Parameters`,
      link: 'project-parameters',
    },
    {
      text: $localize`:@@projectTimeline:Project Timeline`,
      link: 'project-schedule',
    },
    {
      text: $localize`:@@reasons:Reasons`,
      link: 'reasons',
    },
    {
      text: $localize`:@@projectOverviewTasksTab:Project Overview`,
      link: 'overview-tasks',
    }
  ];
  isConfigured: boolean = false;
  isLoading: boolean = false;
  configuredSubscription: Subscription;

  constructor(
    private readonly configService: ConfigService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private activityLog: ActivityLogService
  ) {
    this.configuredSubscription = this.configService.projectConfigStatus$.subscribe(result => {
      this.isConfigured = result.hasProjectConfiguration && result.hasAreaTypes;
      this.cdr.markForCheck();
    });
  }

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_PROJECT_CONFIG });
    this.setIsConfigured();
    this.configService.setupCancel$.subscribe(() => {
      this.cancelSetup();
    });
  }

  ngOnDestroy(): void {
    this.configuredSubscription.unsubscribe();
  }

  async setIsConfigured() {
    try {
    const result = await this.configService.loadProjectConfigStatus();
    if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
    else {
      this.isConfigured = result.hasProjectConfiguration && result.hasAreaTypes;
      if (this.router.url.split('?')[0].endsWith('project-schedule') && !this.isConfigured) {
        this.router.navigate(['project-config'], { relativeTo: this.route.parent });
        return;
      }
      if (this.isConfigured && this.router.url.endsWith('/project-config')) {
        this.router.navigate(['configuration'], { relativeTo: this.route });
      }
      this.cdr.markForCheck();
    }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
    this.isLoading = false;
  }

  setIsConfiguredToTrue() {
    this.isConfigured = true;
    this.cdr.markForCheck();
  }

  cancelSetup() {
    this.isConfigured = false;
    this.cdr.markForCheck();
  }

  goto(item: any) {
    console.log(this.isConfigured);

    if (item.link == 'project-schedule' && !this.isConfigured) {
      this.router.navigate(['project-config'], { relativeTo: this.route.parent });
      return;
    }
    this.router.navigate([item.link], { relativeTo: this.route });
  }
}
